import { DashboardContainer } from '../../../Pages/styles/DashboardPageStyles'
import { SkeletonDashboardHeader } from './SkeletonDashboardHeader'
import { SkeletonProjectGrid } from './SkeletonProjectGrid'

interface SkeletonDashboardProps {
  count?: number
}

export function SkeletonDashboard({ count }: SkeletonDashboardProps) {
  return (
    <DashboardContainer>
      <SkeletonDashboardHeader />
      <SkeletonProjectGrid count={count} />
    </DashboardContainer>
  )
}
